export default __webpack_public_path__ + "static/media/logo-blue.608f0d6e.svg";